import React from 'react';
import AssesmentPage from './AssesmentPage';

const TrainingAssessmentFormPage: React.FC = () => {
  return <AssesmentPage isTrainingAssessment={true} />;
};

export default TrainingAssessmentFormPage;
